/** @file Thai catalog part of area E2 (W3-03), partial; replaced whole by that area. */

/** The `hierarchy`, `assets` and `inspector` panel blocks (spread into `panels`); partial, English fills the gaps. S0 composes it into `th`. */
export const docPanelsTh = {
  hierarchy: {
    title: 'ลำดับชั้น', tree: 'bone และ slot', menu: 'คำสั่งลำดับชั้น', rename: 'เปลี่ยนชื่อ', newBone: 'bone ลูกใหม่', newSlot: 'slot ใหม่',
    remove: 'ลบ…', show: 'แสดง attachment นี้', removeEntry: 'เอาออกจาก skin',
  },
  assets: {
    title: 'แอสเซ็ต', tree: 'รูปภาพและ attachment', menu: 'คำสั่งแอสเซ็ต', createRegion: 'สร้าง region', showInSlot: 'แสดงใน slot ที่เลือก',
    rename: 'เปลี่ยนชื่อ', remove: 'ลบ…',
  },
  inspector: {
    title: 'คุณสมบัติ', name: 'ชื่อ', parent: 'bone แม่', delete: 'ลบ…', length: 'ความยาว', inherit: 'การสืบทอด',
    chooseAnimation: 'เลือก animation ในไทม์ไลน์ก่อนจึงจะใส่คีย์ได้', generated: 'สร้างโดย socket: แก้ที่ socket แทน',
    keyHere: 'มีคีย์ที่เฟรมนี้', keyOther: 'มีคีย์ที่เฟรมอื่น', keysCount: 'เลือก {n} คีย์', verticesCount: 'เลือก {n} จุดยอด',
    kinds: {
      project: 'โปรเจกต์', bone: 'bone', slot: 'slot', region: 'attachment แบบ region', mesh: 'attachment แบบ mesh', image: 'รูปภาพ',
      skin: 'skin', ik: 'IK constraint', event: 'event', socket: 'socket', animation: 'animation', reference: 'ภาพอ้างอิง',
    },
    channels: { x: 'X', y: 'Y', rotation: 'หมุน', scaleX: 'สเกล X', scaleY: 'สเกล Y', shearX: 'เฉือน X', shearY: 'เฉือน Y' },
    key: { frame: 'เฟรม', value: 'ค่า', curve: 'เส้นโค้ง', remove: 'ลบคีย์', inTimeline: 'แก้ค่าของคีย์นี้ในไทม์ไลน์' },
    curve: { mixed: 'หลายแบบ', custom: 'นุ่มนวลแบบกำหนดเอง', bezier: 'เบซิเยร์' },
    mesh: {
      stats: '{vertices} จุดยอด, {triangles} สามเหลี่ยม, ขอบนอก {hull}', rigid: 'แบบแข็ง: ตาม bone {bone}', skinned: 'ผูกน้ำหนักกับ {n} bone',
      weightsHint: 'แก้น้ำหนักได้ในแผง Weights',
    },
  },
} as const;
